import GeoData from './geoData.js';

export class ScalarData extends GeoData {
  constructor(size) {
    super(size);
    this.data = math.zeros([size[0],size[1]]);
  }


  setData(data) {
    if (data.length == this.size[0] && data[0].length == this.size[1]){
      this.data = data;
      this.magmin = Infinity;
      this.magmax = -Infinity;
      for (var ith=0;ith<this.size[0];ith++) {
        for (var iph=0;iph<this.size[1];iph++) {
          this.magmin = Math.min(this.magmin,data[ith][iph]);
          this.magmax = Math.max(this.magmax,data[ith][iph]);
        }
      }
    }
    else {
      throw "ERROR: data size must be " + this.size;
    }
  }
}

export function scalarDataFromJson(json) {
  var ntheta = json.dataarray.length;
  var nphi = json.dataarray[0].length;
  var data = new ScalarData([ntheta,nphi]);
  data.stepθ = json.theta_step;
  data.stepφ = json.phi_step;
  data.setData(json.dataarray);
  return data
}



//////////////////
// WEBPACK FOOTER
// ./src/model/scalarData.js
// module id = 10
// module chunks = 0